import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description LoanCalc icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { LoanCalc } from '@sravni/design-system-icons'
 *
 * <LoanCalc />
 * ```
 */
var LoanCalc = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "LoanCalc", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#LoanCalc__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M11.182 12.667h1.756M11.182 10.583h2.083M2.986 8.5h12.5M10.736 14.75h-6.12c-.9 0-1.63-.73-1.63-1.63V3.88c0-.9.73-1.63 1.63-1.63h9.24c.9 0 1.63.73 1.63 1.63V10M11.32 5.375h2.084M5.07 5.375h2.084M6.111 6.417V4.333M5.375 10.889l1.472 1.472M5.375 12.361l1.472-1.472M9.236 2.25v12.5" })),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.84 12.283a.625.625 0 0 1-.474.746 2.27 2.27 0 1 0 2.692 2.764.625.625 0 0 1 1.212.305 3.516 3.516 0 0 1-2.747 2.605 3.52 3.52 0 0 1-1.43-6.894.625.625 0 0 1 .746.474Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.605 10.891a2.275 2.275 0 1 0 .857 4.468 2.275 2.275 0 0 0-.857-4.468Zm-3.033 2.897a3.525 3.525 0 1 1 6.923-1.326 3.525 3.525 0 0 1-6.923 1.326Z", fill: "currentColor" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "LoanCalc__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(1.736 1)", d: "M0 0h15v15H0z" }))))); });

export { LoanCalc };
//# sourceMappingURL=LoanCalc.js.map
